export default class Traducao {

    constructor (app, painelModules, boxModules) {
        this._painelModules = painelModules
        this._boxesModules = boxModules
        this.idioma = app.appContext.config.globalProperties.$store.getters.idioma
        this.$http = app.appContext.config.globalProperties.$http
        this.$vistra = app.appContext.config.globalProperties.$vistra

        this.TipoOrigem = [
            'painel-nome', 'painel-descricao',
            'notasversao-descricao',
            'seletor-descricao', 'seletor-campo',
            'fontededados-campo',
            'parametroglobal-descricao',
            'objeto-info',
            'objeto-paineldeabas-titulo', 'objeto-paineldeabas-marcacao',
            'objeto-tabela-coluna', 'objeto-tabela-titulo',
            'objeto-tabeladinamica-hint', 'objeto-tabeladinamica-campo', 'objeto-tabeladinamica-titulo',
            'objeto-dbtexto-texto', 'objeto-dbtexto-formatcondicional',
            'objeto-grafico-titulo', 'objeto-grafico-subtitulo', 'objeto-grafico-hint', 'objeto-grafico-serie-nome', 'objeto-grafico-serie-rotulo',
            'objeto-grafico-eixos-titulo', 'objeto-grafico-eixos-linhademeta-rotulo', 'objeto-grafico-legenda',
            'objeto-grafico-top-outros',
            'objeto-medidor-titulo', 'objeto-medidor-subtitulo', 'objeto-medidor-hint', 'objeto-medidor-rotulo', 'objeto-medidor-legenda', 'objeto-medidor-escala-rotulo',
            'objeto-filtro-placeholder', 'objeto-filtro-titulo',
            'objeto-mapa-titulo', 'objeto-mapa-hint',
            'objeto-menu-template-titulo', 'objeto-menu-item-texto', 'objeto-menu-item-hint',
            'objeto-grupoexpansivel-botao-texto', 'objeto-grupoexpansivel-botao-hint',
            'widget-nome'
        ]
        this.removidos = []
        this.frasesIgnoradas = ['{a}', '{v}', '{p}', '{s}', '{a}: {v}', '{a}: {v} ({p})'].concat((Array.from(Array(50).keys())).map(i => `{${i}}`))
        this.regexEditorHTML = new RegExp(`%[^${String.fromCharCode(160)}${String.fromCharCode(32)}%\b\n]+%`, 'g')
        this.regexVariavelUsuario = new RegExp('\\[(\\d+)\\|([^\\]]+)\\]', 'g');
    }

    async mergeTraducao(parametrosExecucao, painelNovo) {
        
        let dicionarioAntigo = painelNovo 
            ? JSON.parse(JSON.stringify(this._painelModules.painel.value.dadosPainel.traducao.dicionario)) 
            : (await this.$http.get(`/Painel/GetTraducaoPainel/${this._painelModules.painel.value.dadosPainel.id}`)).data?.dicionario;
        
        if(!dicionarioAntigo)
            dicionarioAntigo = JSON.parse(JSON.stringify(this._painelModules.painel.value.dadosPainel.traducao.dicionario))
        
        let dicionarioNovo = await this.getTextosTraducao(parametrosExecucao)

        // remove os textos que não existem mais
        for (let i = 0; i < dicionarioAntigo.length; i++) { 
            if (!dicionarioNovo.find(t => t.origem == dicionarioAntigo[i].origem && t.default === dicionarioAntigo[i].default)) { 
                this.removidos.push(dicionarioAntigo.splice(i, 1))
                i--
            }
        }
        // adiciona textos os novos
        for (let textoNovo of dicionarioNovo) {
            if (!dicionarioAntigo.find(t => t.origem == textoNovo.origem && t.default === textoNovo.default)) {
                dicionarioAntigo.push(textoNovo)
            }
        }
        dicionarioAntigo = dicionarioAntigo.filter((item, i) => {
            return i == dicionarioAntigo.indexOf(dicionarioAntigo.find(t => t.origem === item.origem && t.default === item.default));
        })
        return this.$vistra.ordenarPor(dicionarioAntigo, 'tipo')
    }

    removeVariaveis(regex, texto) {
        if (!!texto) {
            (texto.match(regex) || []).forEach((m, index) => texto = texto.split(m).join(`{${index}}`))
        }
        return texto
    }

    addVariaveis(regex, textoOriginal, texto) {
        if (!texto) {
            return textoOriginal
        }
        (textoOriginal.match(regex) || []).forEach((m, index) => texto = texto.split(`{${index}}`).join(m))
        return texto
    }

    removeVariaveisUsuario(texto) {
        return this.removeVariaveis(this.regexVariavelUsuario, texto)
    }

    addVariaveisUsuario(textoOriginal, texto) {
        return this.addVariaveis(this.regexVariavelUsuario, textoOriginal, texto)
    }

    removeVariaveisEditorHTML(texto) {
        return this.removeVariaveis(this.regexEditorHTML, texto)
    }

    addVariaveisEditorHTML(textoOriginal, texto) {
        return this.addVariaveis(this.regexEditorHTML, textoOriginal, texto)
    }  

    async getTextosTraducao(parametrosExecucao) {
        let textos = []
        textos = this.getTextosPainel()
            .concat(this.getTextosNotasDeVersao())
            .concat(await this.getTextosSeletores(parametrosExecucao))
            .concat(this.getTextosFontesDados())
            .concat(this.getTextosParametrosGlobais())
            .concat(this.getTextosObjetos())
            .concat(this.getNomeWidget())
        textos = textos.filter(t => !!t.default && !this.frasesIgnoradas.includes(t.default.toLowerCase()))
        return textos.filter((item, i) => {
            return i == textos.indexOf(textos.find(t => t.origem === item.origem && t.default === item.default));
        })
    }

    getTextosPainel() {
        /*!!! Traduzido em backend !!!*/
        let textos = [{ origem: 'painel-nome', default: this.removeVariaveisUsuario(this._painelModules.painel.value.dadosPainel.nome) }]
        const descricao = this.getTextosDoObjetoHTML(this._painelModules.painel.value.dadosPainel.descricao)
        for (let frase of descricao) {
            textos.push({ origem: 'painel-descricao', default: frase })
        }
        return textos
    }

    getNomeWidget() {
        if (!this._painelModules.painel.value.dadosPainel.dadosWidget)
            return []
        let textos = [{ origem: 'widget-nome', default: this._painelModules.painel.value.dadosPainel.dadosWidget.nome }]
        return textos
    }

    getTextosNotasDeVersao() {
        let textos = []
        for (let versao of this._painelModules.painel.value.dadosPainel.versoesPainel) {
            const descricao = this.getTextosDoObjetoHTML(versao.descricao)
            for (let frase of descricao) {
                textos.push({ origem: 'notasversao-descricao', default: frase })
            }
        }
        return textos
    }

    async getTextosSeletores(parametrosExecucao) {
        /*!!! Traduzido em backend !!!*/
        let listaTextos = []
        for (let sel of (parametrosExecucao?.seletores || [])) {
            listaTextos.push({ origem: 'seletor-descricao', default: this.removeVariaveisUsuario(sel.descricao) })
            if (sel.idSQL) {
                let campos = (await this.$http.get(`/Seletor/GetCamposSQLSeletor/${sel.idSeletor}/${sel.idComponente}/${sel.idSQL}`)).data
                for (let campo of campos) {
                    listaTextos.push({ origem: 'seletor-campo', default: this.removeVariaveisUsuario(campo.titulo) })
                }
            }
        }
        return listaTextos
    }

    getTextosFontesDados() {
        let listaTextos = []
        this._painelModules.painel.value.dadosPainel.fontesDados.filter(fonte => fonte.campos).forEach(fonte => {
            let aux = fonte.campos.map(campo => this.removeVariaveisUsuario(campo.titulo))
            listaTextos = listaTextos.concat(aux);
            fonte.campos.filter(c => c.campoFuncao).forEach(campo => {
                // pega os textos dentro das fórmulas de campos calculados
                listaTextos = listaTextos.concat((campo.funcao.match(new RegExp(`\'(.*?)\'|\"(.*?)\"`, 'g')) || []).map(t => t.split("\'").join("").split('\"').join("")))
        })
        })
        return listaTextos.map(t => {
            return { origem: 'fontededados-campo', default: t }
        })
    }

    getTextosParametrosGlobais() {
        let listaTextos = this._painelModules.painel.value.dadosPainel.parametrosGlobais.map(param => param.descricao)
        return listaTextos.map(t => {
            return { origem: 'parametroglobal-descricao', default: t}
        })
    }

    getTextosObjetos() {
        let textos = []
        
        this._boxesModules.boxes.value.forEach(box => {

            if (box.window?.menu?.info?.text)
                for (let fraseInfo of this.getTextosDoObjetoHTML(box.window.menu.info.text))
                    textos.push({ origem: 'objeto-info', default: fraseInfo })
                    
            switch (box.type) {
                case 'TabPanel':
                    box.objeto().option('items').filter(t => {
                        return !(t.deleted)
                    }).forEach(aba => {
                        textos.push({ origem: 'objeto-paineldeabas-titulo', default: aba.title })
                        textos.push({ origem: 'objeto-paineldeabas-marcacao', default: aba.badge })
                    })
                    break;
                case 'Table':
                    box.componentObj.getColunas(false).forEach(col => {
                        //if (col.captionManual) {
                            textos.push({ origem: 'objeto-tabela-coluna', default: col.caption })
                        //}
                    })
                    
                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option('title.fakeText.text'))) {
                        textos.push({ origem: 'objeto-tabela-titulo', default: frase })
                    }
                    break;
                case 'PivotGrid':
                    textos.push({ origem: 'objeto-tabeladinamica-hint', default: box.objeto().option('hint') })
                    
                    box.objeto().getDataSource().fields().forEach(col => {                
                        //if (col.captionManual) {
                            textos.push({ origem: 'objeto-tabeladinamica-campo', default: col.caption })
                        //}
                    })
                    
                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option('title.fakeText.text'))) {
                        textos.push({ origem: 'objeto-tabeladinamica-titulo', default: frase })
                    }
                    break;
                case 'DBText':
                    for (let frase of this.getTextosDoObjetoHTML(box.componentObj.dados.texto)) {
                        textos.push({ origem: 'objeto-dbtexto-texto', default: frase })
                    }
                    (box.componentObj.dados.formatacaoCondicional || []).forEach(f => {
                        for (let frase of this.getTextosDoObjetoHTML(f.valor.textoPersonalizado)) {
                            textos.push({ origem: 'objeto-dbtexto-formatcondicional', default: frase })
                        }
                    })
                    break;
                case 'Chart':
                case 'ChartPieDonut':
                case 'PolarChart':
                case 'ChartFunnel':
                case 'TreeMap':
                case 'Sparkline':
                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option('title.fakeText.text'))) {
                        textos.push({ origem: 'objeto-grafico-titulo', default: frase })
                    }
                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option('title.subtitle.fakeText.text'))) {
                        textos.push({ origem: 'objeto-grafico-subtitulo', default: frase })
                    }

                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option("tooltip.customizeTooltip_config"))) {
                        textos.push({ origem: 'objeto-grafico-hint', default: frase })
                    }

                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option("legend.customizeText_config"))) {
                        textos.push({ origem: 'objeto-grafico-legenda', default: frase })
                    }

                    if (box.fonteDeDados.tipoSeries === 'dynamic') {
                        for (let frase of this.getTextosDoObjetoHTML(box.objeto().option(`commonSeriesSettings.label.customizeText_config`))) {
                            textos.push({ origem: 'objeto-grafico-serie-rotulo', default: frase })
                        }
                    } else {
                        let qtdSeries = (box.objeto().option('series') || []).length;
                        for (let index = 0; index < qtdSeries; index++) {
                            textos.push({ origem: 'objeto-grafico-serie-nome', default: box.objeto().option(`series[${index}].name`) })                                
                            for (let frase of this.getTextosDoObjetoHTML(box.objeto().option(`series[${index}].label.customizeText_config`))) {
                                textos.push({ origem: 'objeto-grafico-serie-rotulo', default: frase })
                            }
                        }
                    }
                    
                    if (['Chart', 'PolarChart'].includes(box.type)) {

                        //top
                        if (box.type == 'Chart' && (typeof (box.fonteDeDados.top || {}) == 'object' && (box.fonteDeDados.top || {}).ativo)) {
                            if (box.fonteDeDados.top.exibirOutros) {
                                textos.push({ origem: 'objeto-grafico-top-outros', default: box.fonteDeDados.top.textoOutros})
                            }
                        }

                        if (box.fonteDeDados.tipoSeries === 'dynamic') {
                            textos.push({ origem: 'objeto-grafico-eixos-titulo', default: box.objeto().option(`commonAxisSettings.title.fakeText.text`) })
                        } else {            
                            let qtdEixosDeValor = (box.objeto().option('valueAxis') || []).length;
                            for (let index = 0; index < qtdEixosDeValor; index++) {
                                textos.push({ origem: 'objeto-grafico-eixos-titulo', default: box.objeto().option(`valueAxis[${index}].title.fakeText.text`) })
                                let qtdLinhasFixas = (box.objeto().option(`valueAxis[${index}].constantLines`) || []).length
                                for (let idxLinha = 0; idxLinha < qtdLinhasFixas; idxLinha++) {
                                    // textos.push({ origem: 'objeto-grafico-eixos-linhademeta-valor', default: box.objeto().option(`valueAxis[${index}].constantLines[${idxLinha}].value`) })
                                    textos.push({ origem: 'objeto-grafico-eixos-linhademeta-rotulo', default: box.objeto().option(`valueAxis[${index}].constantLines[${idxLinha}].label.text`) })
                                }
                            }
                        }
                                        
                        textos.push({ origem: 'objeto-grafico-eixos-titulo', default: box.objeto().option('argumentAxis.title.text') })    
                        let qtdLinhasFixasA = (box.objeto().option(`argumentAxis.constantLines`) || []).length
                        for (let idxLinhaA = 0; idxLinhaA < qtdLinhasFixasA; idxLinhaA++) {
                            // textos.push({ origem: 'objeto-grafico-eixos-linhademeta-valor', default: box.objeto().option(`argumentAxis.constantLines[${idxLinhaA}].value`) })
                            textos.push({ origem: 'objeto-grafico-eixos-linhademeta-rotulo', default: box.objeto().option(`argumentAxis.constantLines[${idxLinhaA}].label.text`) })
                        }          
                    }
                    break;
                case 'GaugeBar':
                case 'GaugeLinear':
                case 'GaugeCircular':
                case 'GaugeBullet':
                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option('title.fakeText.text'))) {
                        textos.push({ origem: 'objeto-medidor-titulo', default: frase })
                    }
                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option('title.subtitle.fakeText.text'))) {
                        textos.push({ origem: 'objeto-medidor-subtitulo', default: frase })
                    }

                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option("tooltip.customizeTooltip_config"))) {
                        textos.push({ origem: 'objeto-medidor-hint', default: frase })
                    }

                    if (box.type === 'GaugeBar') {                
                        for (let frase of this.getTextosDoObjetoHTML(box.objeto().option(`label.customizeText_config`))) {
                            textos.push({ origem: 'objeto-medidor-rotulo', default: frase })
                        }
                        for (let frase of this.getTextosDoObjetoHTML(box.objeto().option(`legend.customizeText_config`))) {
                            textos.push({ origem: 'objeto-medidor-legenda', default: frase })
                        }
                    } else {
                        for (let frase of this.getTextosDoObjetoHTML(box.objeto().option(`scale.label.customizeText_config`))) {
                            textos.push({ origem: 'objeto-medidor-escala-rotulo', default: frase })
                        }
                    }

                    break;
                case 'FilterDropDown':
                case 'FilterTextBox':
                case 'FilterList':
                    textos.push({ origem: 'objeto-filtro-placeholder', default: box.objeto().option("placeholder") })

                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option("title.text"))) {
                        textos.push({ origem: 'objeto-filtro-titulo', default: frase })
                    }
                    break;
                case 'FilterRange':
                case 'FilterDate':
                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option("title.text"))) {
                        textos.push({ origem: 'objeto-filtro-titulo', default: frase })
                    }
                    break;     
                case 'Mapa':
                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option('title.fakeText.text'))) {
                        textos.push({ origem: 'objeto-mapa-titulo', default: frase })
                    }
                    let qtdCamadas = (box.objeto().option('camadas') || []).length;
                    for (let index = 0; index < qtdCamadas; index++) {
                        for (let frase of this.getTextosDoObjetoHTML(box.objeto().option(`camadas[${index}].apresentacao.dicaDeTela.fakeText.text`))) {
                            textos.push({ origem: 'objeto-mapa-hint', default: frase })
                        }
                    }
                    break;  
                case 'Menu':
                    // Template - Vertical_1
                    for (let frase of this.getTextosDoObjetoHTML(box.objeto().option('template.titulo.fakeTexto'))) {
                        textos.push({ origem: 'objeto-menu-template-titulo', default: frase })
                    }
                    // Fim Template - Vertical_1

                    const varreItens = itens => {
                        itens.forEach(item => {
                            for (let frase of this.getTextosDoObjetoHTML(item.fakeTexto)) {
                                textos.push({ origem: 'objeto-menu-item-texto', default: frase })
                            };
                            if (item.dicaDeTela)
                                textos.push({ origem: 'objeto-menu-item-hint', default: item.dicaDeTela })
                            varreItens(item.itens || [])
                        })
                    }
                    varreItens(box.objeto().option('itens') || [])
                    break;
                case 'GrupoExpansivel':
                    textos.push({ origem: 'objeto-grupoexpansivel-botao-texto', default: box.objeto().option("botao.retraido.texto") })
                    textos.push({ origem: 'objeto-grupoexpansivel-botao-hint', default: box.objeto().option("botao.retraido.hint") })
                    textos.push({ origem: 'objeto-grupoexpansivel-botao-texto', default: box.objeto().option("botao.expandido.texto") })
                    textos.push({ origem: 'objeto-grupoexpansivel-botao-hint', default: box.objeto().option("botao.expandido.hint") })
                    break;
                default:
                    console.log("NÃO ENCONTROU OBJETO TIPO: ", box.type)
                    break;              
            }
        });
        return textos
    }
       
    varreoDOM(node, func) {
        func(node);
        node = node.firstChild;
        while (node) {
            this.varreoDOM(node, func);
            node = node.nextSibling;
        }
    }

    getTextosDoObjetoHTML(textoHTML) {
        var listaTextos = [];
    
        let node = this.createElementFromHTML(textoHTML)
        this.varreoDOM(node, (currentNode) => {
            if (currentNode.nodeType === 3) { //texto (nodeType === 3)
                let valor = currentNode.nodeValue || ""
                if (/{\d+}/.test(valor)) {
                    valor.split(/{\d+}/).forEach(valor2 => {
                        listaTextos.push(valor2.trim());
                    })
                } else
                    listaTextos.push(valor.trim());
            }
        });
    
        // pra não repetir
        return listaTextos.filter(function (item, i) {
            return i == listaTextos.indexOf(item);
        })
    }

    createElementFromHTML(htmlString) {
        var div = document.createElement('div');
        // remove as variáveis do texto
        if (!!htmlString) {
            div.innerHTML = this.removeVariaveisEditorHTML(htmlString);
        }
        return div; 
    }

    aplicaTraducao(tipoOrigem) {
        let startTime = performance.now()

        switch (tipoOrigem) {
            case "painel":
                // PAINEL
                this._painelModules.painel.value.dadosPainel.nome = this.traduzInterno('painel-nome', this._painelModules.painel.value.dadosPainel.nome)
                this._painelModules.painel.value.dadosPainel.descricao = this.traduzInterno('painel-descricao', this._painelModules.painel.value.dadosPainel.descricao, true)
                
                // NOTAS DE VERSÃO
                this._painelModules.painel.value.dadosPainel.versoesPainel.forEach(versao => {
                    versao.descricao = this.traduzInterno('notasversao-descricao', versao.descricao, true)
                })
                break;
            case "execucao":
                // SELETORES
                if (this.parametrosExecucao && this.parametrosExecucao.seletores) {
                    this.parametrosExecucao.seletores.forEach(seletor => {
                        seletor.descricao = this.traduzInterno('seletor-descricao', seletor.descricao)
                    })
                }

                // PARÂMETROS GLOBAIS
                this._painelModules.painel.value.dadosPainel.parametrosGlobais.forEach(param => {
                    param.descricao = this.traduzInterno('parametroglobal-descricao', param.descricao)
                })
                break;
            case "estrutura":
                // FONTES DE DADOS
                this._painelModules.painel.value.dadosPainel.fontesDados.forEach(fonte => {
                    fonte.campos.forEach(campo => {
                        campo.titulo = this.traduzInterno('fontededados-campo', campo.titulo)
                        if (campo.campoFuncao) {
                            // pega os textos dentro das fórmulas de campos calculados
                            (campo.funcao.match(new RegExp(`\'(.*?)\'|\"(.*?)\"`, 'g')) || []).map(t => t.split("\'").join("").split('\"').join("")).forEach(t => {
                                campo.funcao = campo.funcao.split(t.trim()).join(this.traduzInterno('fontededados-campo', t))
                            })
                        }
                    })
                })

                // OBJETOS
                this.aplicaTraducaoObjetos(this._painelModules.painel.value.dadosPainel.estrutura)
                
                break;
        }

        // console.time(`Tempo de tradução (${tipoOrigem}):`, performance.now() - startTime, "ms");
    }

    aplicaTraducaoObjetos(estrutura) {
        if (estrutura != null) {
            var keys = Object.keys(estrutura);
            for (let k of keys) {
                let itemEstruturaPainel = estrutura[k]; 
                
                let box = itemEstruturaPainel.box;
                let props = itemEstruturaPainel.dev;

                if (box.window?.menu?.info?.text)
                    box.window.menu.info.text = this.traduzInterno('objeto-info', box.window.menu.info.text, true)
                
                switch (box.type) {
                    case 'TabPanel':
                        props.filter(p => p.command === 'option' && p.params[0].endsWith("].title") && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-paineldeabas-titulo', p.params[1]))

                        props.filter(p => p.command === 'option' && p.params[0].endsWith("].fakeTitle") && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-paineldeabas-titulo', p.params[1]))

                        props.filter(p => p.command === 'option' && p.params[0].endsWith("].badge") && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-paineldeabas-marcacao', p.params[1]))
                        break;
                    case 'Table':
                        props.filter(p => p.command === "columnOption" && p.params[1] === "caption" && !!p.params[2])
                            .forEach(p => p.params[2] = this.traduzInterno('objeto-tabela-coluna', p.params[2]))

                        props.filter(p => p.command === "option" && p.params[0] === "title.fakeText.text" && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-tabela-titulo', p.params[1], true))
                        break;
                    case 'PivotGrid':
                        props.filter(p => p.command === "option" && p.params[0] === "hint" && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-tabeladinamica-hint', p.params[1]))

                        props.filter(p => p.command === "dataSource.field" && p.params[1] === "caption" && !!p.params[2])
                            .forEach(p => p.params[2] = this.traduzInterno('objeto-tabeladinamica-campo', p.params[2]))

                        // to do não está guardando a opção captionManual. corrigir
                        // box.objeto().getDataSource().fields().forEach(col => {                
                        //     if (col.captionManual) {
                        //         textos.push({ origem: 'objeto-tabeladinamica-campo', default: col.caption })
                        //     }
                        // })

                        props.filter(p => p.command === "option" && p.params[0] === "title.fakeText.text" && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-tabeladinamica-titulo', p.params[1], true))
                        break;
                    case 'DBText':
                        itemEstruturaPainel.own.texto = this.traduzInterno('objeto-dbtexto-texto', itemEstruturaPainel.own.texto, true)
                        for (let index = 0; index < (itemEstruturaPainel.own.formatacaoCondicional || []).length; index++) {
                            itemEstruturaPainel.own.formatacaoCondicional[index].valor.textoPersonalizado = this.traduzInterno('objeto-dbtexto-formatcondicional', itemEstruturaPainel.own.formatacaoCondicional[index].valor.textoPersonalizado, true)
                        }
                        break;
                    case 'Chart':
                    case 'ChartPieDonut':
                    case 'ChartFunnel':
                    case 'Sparkline':
                    case 'PolarChart':
                    case 'TreeMap':

                        props.filter(p => p.command === "option" && p.params[0] === "title.fakeText.text" && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-grafico-titulo', p.params[1], true))
                        props.filter(p => p.command === "option" && p.params[0] === "title.subtitle.fakeText.text" && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-grafico-subtitulo', p.params[1], true))

                        props.filter(p => p.command === "option" && p.params[0] === "tooltip.customizeTooltip_config" && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-grafico-hint', p.params[1]))

                        props.filter(p => p.command === "option" && p.params[0] === "legend.customizeText_config" && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-grafico-legenda', p.params[1])) //

                        if (box.fonteDeDados.tipoSeries === 'dynamic') {
                            props.filter(p => p.command === "option" && p.params[0] === "commonSeriesSettings.label.customizeText_config" && !!p.params[1])
                                .forEach(p => p.params[1] = this.traduzInterno('objeto-grafico-serie-rotulo', p.params[1]))
                        } else {
                            props.filter(p => p.command === "series" && p.params[1] === "name" && !!p.params[2])
                                .forEach(p => p.params[2] = this.traduzInterno('objeto-grafico-serie-nome', p.params[2]))
                            props.filter(p => p.command === "series" && p.params[1] === "label.customizeText_config" && !!p.params[2])
                                .forEach(p => p.params[2] = this.traduzInterno('objeto-grafico-serie-rotulo', p.params[2]))
                        }

                        if (['Chart', 'PolarChart'].includes(box.type)) {

                            //top
                            if (box.type == 'Chart' && (typeof (box.fonteDeDados.top || {}) == 'object' && (box.fonteDeDados.top || {}).ativo)) {
                                if (box.fonteDeDados.top.exibirOutros) {
                                    //aplicar
                                    box.fonteDeDados.top.textoOutros = this.traduzInterno('objeto-grafico-top-outros', box.fonteDeDados.top.textoOutros)
                                }
                            }

                            if (box.fonteDeDados.tipoSeries === 'dynamic') {
                                props.filter(p => p.command === "option" && p.params[0] === ("commonAxisSettings.title.text") && !!p.params[1])
                                    .forEach(p => p.params[1] = this.traduzInterno('objeto-grafico-eixos-titulo', p.params[1]))
                            } else {
                                props.filter(p => p.command === "valueAxis" && p.params[1] === "title.text" && !!p.params[2])
                                    .forEach(p => p.params[2] = this.traduzInterno('objeto-grafico-eixos-titulo', p.params[2]))
                                props.filter(p => p.command === "valueAxis" && p.params[1].startsWith("constantLines[") && p.params[1].endsWith("].label.text") && !!p.params[2])
                                    .forEach(p => p.params[2] = this.traduzInterno('objeto-grafico-eixos-linhademeta-rotulo', p.params[2]))
                            }

                            props.filter(p => p.command === "option" && p.params[0] === "argumentAxis.title.text" && !!p.params[1])
                                .forEach(p => p.params[1] = this.traduzInterno('objeto-grafico-eixos-titulo', p.params[1]))
                            props.filter(p => p.command === "argumentAxis.constantLines" && p.params[1] === "label.text" && !!p.params[2])
                                .forEach(p => p.params[2] = this.traduzInterno('objeto-grafico-eixos-linhademeta-rotulo', p.params[2]))
                        }

                        break;
                    case 'GaugeBar':
                    case 'GaugeLinear':
                    case 'GaugeCircular':
                    case 'GaugeBullet':
                        props.filter(p => p.command === "option" && p.params[0] === "title.fakeText.text" && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-medidor-titulo', p.params[1], true))
                        props.filter(p => p.command === "option" && p.params[0] === "title.subtitle.fakeText.text" && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-medidor-subtitulo', p.params[1], true))

                        props.filter(p => p.command === "option" && p.params[0] === "tooltip.customizeTooltip_config" && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-medidor-hint', p.params[1]))

                        if (box.type === 'GaugeBar') {
                            props.filter(p => p.command === "option" && p.params[0] === "label.customizeText_config" && !!p.params[1])
                                .forEach(p => p.params[1] = this.traduzInterno('objeto-medidor-rotulo', p.params[1]))
                            props.filter(p => p.command === "option" && p.params[0] === "legend.customizeText_config" && !!p.params[1])
                                .forEach(p => p.params[1] = this.traduzInterno('objeto-medidor-legenda', p.params[1]))
                        } else {
                            props.filter(p => p.command === "option" && p.params[0] === "scale.label.customizeText_config" && !!p.params[1])
                                .forEach(p => p.params[1] = this.traduzInterno('objeto-medidor-escala-rotulo', p.params[1]))
                        }
                        break;
                    case 'FilterDropDown':
                    case 'FilterTextBox':
                    case 'FilterList':
                        itemEstruturaPainel.own.config.placeholder = this.traduzInterno('objeto-filtro-placeholder', itemEstruturaPainel.own.config.placeholder)

                        props.filter(p => p.command === "option" && p.params[0] === "title.fakeText.text" && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-filtro-titulo', p.params[1], true))
                        break;
                    case 'FilterRange':
                    case 'FilterDate':
                        itemEstruturaPainel.own.config.titulo = this.traduzInterno('objeto-filtro-titulo', itemEstruturaPainel.own.config.titulo)

                        props.filter(p => p.command === "option" && p.params[0] === "title.fakeText.text" && !!p.params[1])
                            .forEach(p => p.params[1] = this.traduzInterno('objeto-filtro-titulo', p.params[1], true))
                        break;
                    case 'Mapa':
                        itemEstruturaPainel.own.title.fakeText.text = this.traduzInterno('objeto-mapa-titulo', itemEstruturaPainel.own.title.fakeText.text, true)
                        itemEstruturaPainel.own.title.text = itemEstruturaPainel.own.title.fakeText.text
                        itemEstruturaPainel.own.camadas.forEach(camada => {
                            camada.apresentacao.dicaDeTela.fakeText.text = this.traduzInterno('objeto-mapa-hint', camada.apresentacao.dicaDeTela.fakeText.text, true)
                            camada.apresentacao.dicaDeTela.text = camada.apresentacao.dicaDeTela.fakeText.text
                        })
                        break;
                    case 'Menu':
                        itemEstruturaPainel.own.template.titulo.fakeTexto = this.traduzInterno('objeto-menu-template-titulo', itemEstruturaPainel.own.template.titulo.fakeTexto, true)
                        itemEstruturaPainel.own.template.titulo.texto = itemEstruturaPainel.own.template.titulo.fakeTexto

                        const varreItens = itens => {
                            itens.forEach(item => {
                                if (item.fakeTexto) {
                                    item.fakeTexto = this.traduzInterno('objeto-menu-item-texto', item.fakeTexto, true)
                                    item.texto = item.fakeTexto
                                }
                                if (item.dicaDeTela) {
                                    item.dicaDeTela = this.traduzInterno('objeto-menu-item-hint', item.dicaDeTela)
                                }
                                varreItens(item.itens || [])
                            })
                        }
                        varreItens(itemEstruturaPainel.own.itens || [])
                        break;
                    case 'GrupoExpansivel':
                        itemEstruturaPainel.own.botao.retraido.texto = this.traduzInterno('objeto-grupoexpansivel-botao-texto', itemEstruturaPainel.own.botao.retraido.texto)
                        itemEstruturaPainel.own.botao.retraido.hint = this.traduzInterno('objeto-grupoexpansivel-botao-hint', itemEstruturaPainel.own.botao.retraido.hint)
                        itemEstruturaPainel.own.botao.expandido.texto = this.traduzInterno('objeto-grupoexpansivel-botao-texto', itemEstruturaPainel.own.botao.expandido.texto)
                        itemEstruturaPainel.own.botao.expandido.hint = this.traduzInterno('objeto-grupoexpansivel-botao-hint', itemEstruturaPainel.own.botao.expandido.hint)
                        break;
                    default:
                        console.bomb("NÃO ENCONTROU OBJETO TIPO:", box.type)
                        break;
                }
            }
        }
    }

    traduzInterno(origem, textoOriginal, isHtml) {
        return this.traduz(this._painelModules.painel.value.dadosPainel.traducao && this._painelModules.painel.value.dadosPainel.traducao.dicionario, origem, textoOriginal, isHtml);
    }

    trataCaracteres(texto) {
        return texto ? texto.replace(/&nbsp;/g, " ").replace(/\u00A0/g, " ") : texto;
    }

    escapeRegExp(text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&').replace(/\s/g, '\\s');
    }

    traduz(dicionario, origem, textoOriginal, isHtml) {
        if (isHtml) {
            let textoTraduzido = textoOriginal
            // pega traduções e ordena em ordem descrescente pra não substituir errado caso ex: compra, compra e venda
            let traducoes = this.getTextosDoObjetoHTML(textoOriginal).sort((a, b) => {
                if (a.length > b.length) return -1; if (a.length < b.length) return 1; return 0;
            }).map(frase => {
                return {
                    textoOriginal: frase,
                    textoTraduzido: this.traduz(dicionario, origem, frase)
                }
            })
            if (traducoes.length) {
                textoTraduzido = this.trataCaracteres(textoOriginal)
                for (let frase of traducoes) {
                    frase.textoOriginal = this.trataCaracteres(this.addVariaveisEditorHTML(textoTraduzido, frase.textoOriginal))
                    frase.textoTraduzido = this.trataCaracteres(this.addVariaveisEditorHTML(textoTraduzido, frase.textoTraduzido))
                    
                    let imagens = frase.textoOriginal.match(new RegExp(`<img.*?src=['|"][^'|"]*['|"].*?/?>`, 'mgi'));
                    if(imagens) {
                        //Substitui as imagens com o base64 por somente o index dela, para não dar problema no escape.
                        imagens.forEach((img, i) => {
                            frase.textoOriginal = frase.textoOriginal.split(new RegExp(`${this.escapeRegExp(img.substr(1, 999))}.*\/?>`, 'gim')).join(`<img src="${i}">`)
                        })
                    }
                    
                    let variaveis = textoTraduzido.match(this.regexEditorHTML),
                        separador = new RegExp(`(?<=[\\s<>])${this.escapeRegExp(frase.textoOriginal)}(?=[\\s<>])`, 'gi'); //só pega textos dentro entre tags >< pra não pegar o que não é realmente texto
                    
                    if (!!variaveis)
                        textoTraduzido = textoTraduzido.split(this.regexEditorHTML).reduce((agg, atual, index) => {
                            let splitText = atual.split(separador);
                            let replacedText = '';

                            if (splitText.length > 1)
                                replacedText = splitText.join(frase.textoTraduzido) //funciona como replaceAll
                            else
                                replacedText = atual.replaceAll(frase.textoOriginal, frase.textoTraduzido);
                            
                            return ((index > 0) ? (agg + variaveis[index-1]) : "") + replacedText //funciona como replaceAll
                        }, "")
                    else{
                        let splitText = textoTraduzido.split(separador);
                        
                        if (splitText.length > 1)
                            textoTraduzido = splitText.join(frase.textoTraduzido) //funciona como replaceAll
                        else
                            textoTraduzido = textoTraduzido.replaceAll(frase.textoOriginal, frase.textoTraduzido);
                    }
                        

                    if(imagens) {
                        //Volto como era anteriormente
                        imagens.forEach((img, i) => {
                            textoTraduzido = textoTraduzido.split(new RegExp(`<img src="${i}">`, 'mgi')).join(img)
                        })
                    }
                }
            }
            return textoTraduzido
        } else {
            let textoOriginalTratado = this.trataCaracteres(textoOriginal);
            let traducao = (dicionario || []).find(t => {
                let traducaoDefaultTratada = this.trataCaracteres(t.default);
                
                let matchOrigem = t.origem === origem;
                let matchTextoOriginal = traducaoDefaultTratada === this.trataCaracteres(this.removeVariaveisUsuario(textoOriginalTratado)) 
                    || traducaoDefaultTratada === this.trataCaracteres(this.removeVariaveisEditorHTML(textoOriginalTratado)); 
                
                return matchOrigem && matchTextoOriginal;
            })
            
            return traducao && (this.addVariaveisUsuario(textoOriginalTratado, traducao[this.idioma]) || this.addVariaveisEditorHTML(textoOriginalTratado, traducao[this.idioma])) || textoOriginalTratado
        }
    }
}